/* Copyright (c) 2026 Dobler Data Solutions, LLC. All rights reserved. */

import { NavLink } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

/** minimumRole = lowest role that can see this nav item (hierarchy-based) */
const navItems = [
  { to: '/formulas', label: 'Formulas', icon: '📋', minimumRole: 'Pharmacist' },
  { to: '/taxonomy', label: 'Taxonomy', icon: '🏷️', minimumRole: 'Pharmacist' },
  { to: '/dashboard', label: 'Dashboard', icon: '📊', minimumRole: 'Manager' },
  { to: '/users', label: 'Users', icon: '👥', minimumRole: 'Admin' },
  { to: '/settings', label: 'Settings', icon: '⚙️', minimumRole: 'Pharmacist' },
  { to: '/help', label: 'Help', icon: '❓', minimumRole: 'Pharmacist' },
];

export function Sidebar() {
  const hasRole = useAuthStore((s) => s.hasRole);

  const visibleItems = navItems.filter((item) => hasRole(item.minimumRole));

  return (
    <aside className="w-52 bg-white border-r border-gray-200 shrink-0">
      <nav className="py-4">
        {visibleItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2 text-sm transition-colors ${
                isActive
                  ? 'bg-dds-blue-50 text-dds-blue-500 font-medium border-r-2 border-dds-blue-500'
                  : 'text-gray-700 hover:bg-gray-50'
              }`
            }
          >
            <span>{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
